module.exports = __webpack_public_path__ + "img/myvoco.e0a4c6fd.png";